import { Delete, Get, Post, PostFormData } from "../Request/Api";

export default {
  state: {
    manuals: [],
    totalRecords: 0,
    downloadManual: []
  },
  getters: {
    GetManuals(state: any) {
      return state.manuals;
    },
    getDownloadManual(state){
      return state.downloadManual
    }
  },
  actions: {
    async GetDigitalManualWeb({ commit }: any, payload: any) {
      return await Get(
        `DigitalManual/GetDigitalManualByUserId?userId=${payload.userId}&search=${
          payload.search
        }&filter=${payload.filters}&page=${payload.page}&pageSize=${payload.pageSize}`
      ).then((res: any) => {
        console.log("digital manuals",res?.data?.Data)
        commit("SetManuals", res.data.Data);

        return res.data;
      });
    },
    async getDownloadManual({commit},id){
      return await Get(`DigitalManual/GetDigitalManualInBinary?Id=${id}`).then((res: any) =>{
        commit("setDownloadManual", res?.data?.Data)
        return res.data;
      })
    }
  },
  mutations: {
    SetManuals(state: any, payload: any) {
        payload = payload?.List?.map((x: any) => {
            x.File = 
            x.File != null &&
            x.File != undefined &&
            x.File != ""
              // ? process.env.VUE_APP_IMG_URL + x.File
              ? x.File
              : x.File;

                x.Thumbnail =
                x.Thumbnail != null &&
                x.Thumbnail != undefined &&
                x.Thumbnail != ""
                  ? x.Thumbnail
                  : "https://images.unsplash.com/photo-1470770841072-f978cf4d019e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxleHBsb3JlLWZlZWR8Nnx8fGVufDB8fHx8&w=1000&q=80";
            return x;
          });
        console.log("Manuals 2",payload);
        state.manuals = payload;
    },
    setDownloadManual(state: any, payload: any) {
      state.downloadManual = payload;
    }
  },
};
